/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Nowpayments
 */
export class Nowpayments {
    /**
     *
     * @type {string}
     * @memberof Nowpayments
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Nowpayments
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Nowpayments
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Nowpayments
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof Nowpayments
     */
    secretKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Nowpayments
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Nowpayments
     */
    autoApprove: boolean;
}
